import React from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';

import { useTranslation } from '../i18n';
import { PluginQueryFilters } from '../types/types';

interface EntityPickerModalNoSearchResultsProps {
  clearFilters?: () => void;
  filters?: PluginQueryFilters;
}

const getTexts = (
  t: ReturnType<typeof useTranslation>['t'],
  filters: PluginQueryFilters,
) => {
  const hasSearch = !!filters.searchExpression;
  const hasFilters = !!Object.keys(filters).filter(
    (k) => k !== 'searchExpression',
  ).length;
  if (hasSearch && hasFilters) {
    return {
      description: t('NO_SEARCH_AND_FILTER_RESULTS'),
      clearText: t('SHOW_ALL'),
    };
  } else if (hasSearch) {
    return {
      description: t('NO_SEARCH_RESULTS'),
      clearText: t('CLEAR_SEARCH'),
    };
  }
  return {
    description: t('NO_FILTER_RESULTS'),
    clearText: t('CLEAR_FILTERS'),
  };
};

const EntityPickerModalNoSearchResults: React.FC<
  EntityPickerModalNoSearchResultsProps
> = ({ clearFilters, filters }) => {
  const { t } = useTranslation();
  const { description, clearText } = getTexts(t, filters || {});
  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_PHOTO_GREY}
      title={t('NO_RESULTS_TITLE')}
      description={description}
    >
      <LinkButton onClick={clearFilters}>{clearText}</LinkButton>
    </EmptyState>
  );
};

export default EntityPickerModalNoSearchResults;
